import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle
} from 'design-system';
import { useNavigate } from 'react-router';

export const SharedDashboardExpired = () => {
  const navigate = useNavigate();

  return (
    <Empty className='min-h-[60vh]'>
      <EmptyHeader>
        <EmptyTitle className='text-xl'>This link has expired</EmptyTitle>
        <EmptyDescription>
          Dashboard share links are only valid for 30 days. If you still need access, please ask the
          sender to share it again.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          onClick={() => {
            navigate('/');
          }}
        >
          Go to Homepage
        </Button>
      </EmptyContent>
    </Empty>
  );
};
